import React from 'react';
import propTypes from 'prop-types';
import {
  LiveKitRoom,
  VideoConference,
} from '@livekit/components-react';
import '@livekit/components-styles';
import RaiseHandListener from './RaiseHandListener';
import RaisedHandTracker from './RaisedHandTracker';
import AttendanceTracker from './AttendanceTracker';

import './externalVideoComponent.css';

import redirectToHome from '../../utils/redirects/home';
import post from '../../utils/fetchRequests/post';
import Loader from '../Loader';
import {
  // frontendUrl,
  publicJoinUrl,
  // movieFrontEndURL,
  myAnatomyHomePageUrl,
  backendUrl,
  // codeFrameFrontEndUrl,
  // codeFrameBackEndUrl,
  LIVEKIT_URL,
} from '../../configFiles/config';

import ModeratorTopNavBar from '../ModeratorTopNavBar';
import TopNavBar from '../TopNavBar';
import ParticipantOverlay from './ParticipantOverlay';
// import { toolbarOptions } from './constant';


class ExternalVideoComponent extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showDummyLoader: true,
      showParticipants: false,
      raisedHandCount: 0,
      participantCount: 0,
    };
  }

  componentDidMount () {
    const {
      token,
      connectingVideoId,
    } = this.props;
    // console.log('props', this.props);

    if (!token || !connectingVideoId) {
      redirectToHome('Cannot start meeting');
    }

    setTimeout(() => {
      this.setState(() => ({
        showDummyLoader: false,
      }));
    }, 3000);
  }

  handleMeetingEnd = async () => {
    const { token } = this.props;
    if (token) {
      try {
        await post(`${backendUrl}/api/v1/meeting/attendance/leave`, {}, {
          authorization: token,
        });
      } catch (error) {
        fetch(`${backendUrl}/api/v1/meeting/attendance/leave`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            authorization: token,
          },
          body: '{}',
          keepalive: true,
        }).catch(() => {});
      }
    }
    window.location.href = myAnatomyHomePageUrl;
  }

  toggleParticipants = () => {
    this.setState((prevState) => ({
      showParticipants: !prevState.showParticipants,
    }));
  };

  setRaisedHandCount = (count) => {
    this.setState({ raisedHandCount: count });
  };

  setParticipantCount = (count) => {
    this.setState({ participantCount: count });
  };

  render () {
    const {
      // connectingVideoId,
      // name,
      meetingId,
      isModerator,
      token,
      useMyMeetingMicroService,
      livekitToken,
    } = this.props;

    const {
      showDummyLoader,
      showParticipants,
      raisedHandCount,
      participantCount,
    } = this.state;

    let joinUrl = publicJoinUrl;

    if (joinUrl) {
      joinUrl = joinUrl.replace('<<meetingId>>', meetingId);
    }
    // const domainForMovie = useMyMeetingMicroService ? movieFrontEndURL : externalVideoDomain;
    
    // Fallback if livekitToken is not yet available but we are in the flow
    // if (!livekitToken && !useMyMeetingMicroService) {
    //   return <Loader />;
    // }

        
    // const showLiveKit = !!livekitToken;

    return (
      <div className='externalVideoComponent'>
        <div className='externalVideoComponentTopNavBarContainer'>
          {
            isModerator ?
              <ModeratorTopNavBar
                toggleParticipants={this.toggleParticipants}
                raisedHandCount={raisedHandCount}
                participantCount={participantCount}
              />
              :
              <TopNavBar
                toggleParticipants={this.toggleParticipants}
                raisedHandCount={raisedHandCount}
              />
          }
        </div>
        
        {
          // !showLiveKit && useMyMeetingMicroService ?
          //   <iframe
          //     // allow={`camera ${myMeetingFrontEndURL}; microphone ${myMeetingFrontEndURL}`}
          //     allow={`camera *; microphone *; display-capture; clipboard-write`}
          //     src={`${externalVideoDomain}/meeting/join?meetingId=${meetingId}&meetingToken=${token}`}
          //     className='myMeetingContainer'
          //   />
          //   :
            <LiveKitRoom
              video={true}
              audio={true}
              token={livekitToken}
              serverUrl={LIVEKIT_URL}
              data-lk-theme="default"
              style={{ height: '93vh', width: '100vw' }}
              onDisconnected={this.handleMeetingEnd}
            >
              <AttendanceTracker meetingToken={token} />
              <VideoConference />
              <RaiseHandListener />
              <RaisedHandTracker
                onCountChange={this.setRaisedHandCount}
                onParticipantCountChange={this.setParticipantCount}
              />
              <ParticipantOverlay
                open={showParticipants}
                onClose={this.toggleParticipants}
                isModerator={isModerator}
                meetingId={meetingId}
                token={token}
              />
            </LiveKitRoom>
        }
        {
          !livekitToken ?
            <Loader />
            :
            null
        }
      </div>
    );
  }
}

ExternalVideoComponent.propTypes = {
  token: propTypes.string,
  connectingVideoId: propTypes.string,
  name: propTypes.string,
  email: propTypes.string,
  meetingId: propTypes.string,
  isModerator: propTypes.bool,
  useMyMeetingMicroService: propTypes.bool,
  livekitToken: propTypes.string,
};

ExternalVideoComponent.defaultProps = {
  token: '',
  connectingVideoId: '',
  name: '',
  email: '',
  meetingId: '',
  isModerator: false,
  useMyMeetingMicroService: false,
  livekitToken: '',
};

export default ExternalVideoComponent;
